import guest from './rules/guest';
import auth from './rules/auth';
import masterAuth from './rules/masterAuth';
import masterGuest from './rules/masterGuest';

export default {
    guest, auth, masterAuth, masterGuest
}